import { observer } from 'mobx-react-lite';
import { Outlet } from 'react-router-dom';
import { useTimetableStore } from '../../../../components/TimetableGrid/TimetableProvider';
import { TimetableVersionTopBar } from '../../../../components/TimetableVersion/TimetableVersionTopBar/TimetableVersionTopBar';

export type BlockPhase = 'future' | 'running' | 'past' | null;

export const TimetableVersionLayout = observer(
  ({
    versionUuid,
    baseSlug,
    blockPhase,
    onStartFix,
    onCompleteFix,
  }: {
    versionUuid: string;
    baseSlug: string;
    blockPhase: BlockPhase;
    onStartFix?: () => Promise<void>;
    onCompleteFix?: () => Promise<boolean>;
  }) => {
    const pinboardStore = useTimetableStore();
    return (
      <>
        {pinboardStore.temporarilyEditable && (
          <div
            style={{
              position: 'fixed',
              inset: 0,
              boxShadow: 'inset 0 0 0 3px var(--color-warning)',
              pointerEvents: 'none',
              zIndex: 9999,
            }}
          />
        )}
        <TimetableVersionTopBar
          versionUuid={versionUuid}
          baseSlug={baseSlug}
          blockPhase={blockPhase}
          onStartFix={onStartFix}
          onCompleteFix={onCompleteFix}
        />
        <Outlet />
      </>
    );
  },
);
